// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"265":"canvg","297":"xlsx","643":"pdfmake"}[chunkId] || chunkId) + "." + {"265":"96e69351","297":"9cc78d0e","643":"a8fd2041","787":"b0577ffd","959":"d0158866"}[chunkId] + ".chunk.js";
};